import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCheckboxChange, MatDialogRef, MatRadioChange } from '@angular/material';
import { hasTag } from '../../util/tag-utils';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { TagService } from '../../shared/services/tag.service';
import { FlyingClub } from '../models/flying-club.model';
var EditClubDetailsComponent = /** @class */ (function () {
    function EditClubDetailsComponent(_matDialogRef, data, _businessManagerService, _tagService) {
        this._matDialogRef = _matDialogRef;
        this._businessManagerService = _businessManagerService;
        this._tagService = _tagService;
        this.isLoading = false;
        this.memberSizePlaceHolder = 'Average Membership Size';
        this._equityClubTag = 'Flying Club::Equity Club';
        this._membershipAvailTag = 'Flying Club::Membership::Open';
        this._membershipWaitingListTag = 'Flying Club::Membership::Waiting List';
        this.business = data.business;
    }
    EditClubDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close(null);
        });
        this._originalClubData = Object.assign(new FlyingClub(), this.business.flyingClub);
        this.formGroup = new FormGroup({
            orgType: new FormControl(''),
            aveNumMembers: new FormControl(''),
            numOfAC: new FormControl(''),
            membershipsAvail: new FormControl('')
        });
        this.isForProfit = hasTag(this.business.tags, this._equityClubTag);
        this.isAvailable = hasTag(this.business.tags, this._membershipAvailTag);
        this.hasWaitingList = hasTag(this.business.tags, this._membershipWaitingListTag);
    };
    EditClubDetailsComponent.prototype.forProfitChanged = function (radioChange) {
        if (radioChange.source.value === '1' && !this.isForProfit) {
            this.isForProfit = true;
        }
        else if (radioChange.source.value === '2' && this.isForProfit) {
            this.isForProfit = false;
        }
    };
    EditClubDetailsComponent.prototype.membershipChanged = function (radioChange) {
        if (radioChange.source.value === '1' && !this.isAvailable) {
            this.isAvailable = true;
            this.hasWaitingList = false;
        }
        else if (radioChange.source.value === '2' && this.isAvailable) {
            this.isAvailable = false;
        }
    };
    EditClubDetailsComponent.prototype.waitingListChecked = function (checkbox) {
        if (checkbox.checked) {
            this.hasWaitingList = true;
        }
        else {
            this.hasWaitingList = false;
        }
    };
    EditClubDetailsComponent.prototype.aveMemberUnfocussed = function () {
        var MEMBERS = this.business.flyingClub.clubMembers;
        this.business.flyingClub.clubMembers = (!MEMBERS || MEMBERS < 0) ? 0 : Math.floor(MEMBERS);
    };
    EditClubDetailsComponent.prototype.numOfACUnfocussed = function () {
        var AIRCRAFT = this.business.flyingClub.clubAircraft;
        this.business.flyingClub.clubAircraft = (!AIRCRAFT || AIRCRAFT < 0) ? 0 : Math.floor(AIRCRAFT);
    };
    EditClubDetailsComponent.prototype.close = function (success) {
        if (success === null) {
            Object.assign(this.business.flyingClub, this._originalClubData);
        }
        this._matDialogRef.close(success);
    };
    EditClubDetailsComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var EQUITY_TAG_ID, MEMBER_AVAIL_TAG_ID, MEMBER_WAITING_LIST_TAG_ID, newBusiness, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 15, , 16]);
                        EQUITY_TAG_ID = 42873;
                        MEMBER_AVAIL_TAG_ID = 42842;
                        MEMBER_WAITING_LIST_TAG_ID = 49285;
                        if (!(this.isForProfit && !hasTag(this.business.tags, this._equityClubTag))) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._tagService.postTag(EQUITY_TAG_ID, this.business.id)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        if (!(!this.isForProfit && hasTag(this.business.tags, this._equityClubTag))) return [3 /*break*/, 5];
                        return [4 /*yield*/, this._tagService.deleteTag(EQUITY_TAG_ID, this.business.id)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        if (!(this.isAvailable && !hasTag(this.business.tags, this._membershipAvailTag))) return [3 /*break*/, 7];
                        return [4 /*yield*/, this._tagService.postTag(MEMBER_AVAIL_TAG_ID, this.business.id)];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 7:
                        if (!(!this.isAvailable && hasTag(this.business.tags, this._membershipAvailTag))) return [3 /*break*/, 9];
                        return [4 /*yield*/, this._tagService.deleteTag(MEMBER_AVAIL_TAG_ID, this.business.id)];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        if (!(this.hasWaitingList && !hasTag(this.business.tags, this._membershipWaitingListTag))) return [3 /*break*/, 11];
                        return [4 /*yield*/, this._tagService.postTag(MEMBER_WAITING_LIST_TAG_ID, this.business.id)];
                    case 10:
                        _a.sent();
                        return [3 /*break*/, 13];
                    case 11:
                        if (!(!this.hasWaitingList && hasTag(this.business.tags, this._membershipWaitingListTag))) return [3 /*break*/, 13];
                        return [4 /*yield*/, this._tagService.deleteTag(MEMBER_WAITING_LIST_TAG_ID, this.business.id)];
                    case 12:
                        _a.sent();
                        _a.label = 13;
                    case 13: return [4 /*yield*/, this._businessManagerService.updateBusiness(this.business)];
                    case 14:
                        newBusiness = _a.sent();
                        Object.assign(this.business, newBusiness);
                        return [3 /*break*/, 16];
                    case 15:
                        e_1 = _a.sent();
                        this.close(false);
                        this.isLoading = false;
                        return [2 /*return*/];
                    case 16:
                        this.isLoading = false;
                        this.close(true);
                        return [2 /*return*/];
                }
            });
        });
    };
    return EditClubDetailsComponent;
}());
export { EditClubDetailsComponent };
